///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching = abcsetup.new_customer_matching || {};
abcsetup.new_customer_matching.events = abcsetup.new_customer_matching.events || {};
abcsetup.new_customer_matching.events.items = abcsetup.new_customer_matching.events.items || {};
abcsetup.new_customer_matching.events.items.index = abcsetup.new_customer_matching.events.items.index || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.new_customer_matching.events.items.index = {
    init: function () {
        const _this = this;

        $(document).on("change", "input.batch", function() {
            let hasMatch = true;
            let numSelected = 0;

            /* reset state on change to be altered later */
            $('.batch-reassign').prop('disabled', true);
            $('#bulk-actions .batch-action').prop('disabled', true);

            $('input.batch').each(function(i, e) {
                if ($(this).is(':checked')) {
                    if ($(this).data('has_match') == 'no') {
                        hasMatch = false;
                    }

                    numSelected++;
                }
            });

            if (numSelected > 0) {
                if (hasMatch) {
                    $('#bulk-actions .batch-action').prop('disabled', false);
                }

                $('.batch-reassign').prop('disabled', false);
            }
        });

        $(document).on("change", "#batch-all", function() {
            $(this).is(':checked')
                ? $('input.batch').prop('checked', true).trigger('change')
                : $('input.batch').prop('checked', false).trigger('change');
        });

        $(document).on("click", ".batch-action", function(){
            const action = $(this).val();
            const event_start_date = $('#event_start_date').val();
            const event_end_date = $('#event_end_date').val();
            let phrase = action;
            let date_warning = '';

            if(action == "approve"){
                phrase = "request new bid(s) for";
            }else if(action == "wac"){
                phrase = "submit bid(s) at wac for";
            }

            $('input.batch:checked').each(function(i, e){
                let item_start_date = $('#item_start_date_' + $(e).val()).val();
                let item_end_date = $('#item_end_date_' + $(e).val()).val();

                if (item_start_date !== event_start_date || item_end_date !== event_end_date) {
                    date_warning = '<p class="alert alert-danger mt-2">Some item(s) have different start and end dates than the event.</p>';
                }
            });

            abcsetup.alerts.confirm('Batch Action Confirmation', "Are you sure you want to " + phrase + " the selected item(s)?" + date_warning, function(resp){
                if(!resp){
                    return;
                }

                let payload = [];

                $('input.batch:checked').each(async function(i, e){
                    let item_start_date = $('#item_start_date_' + $(e).val()).val();
                    let item_end_date = $('#item_end_date_' + $(e).val()).val();

                    payload.push({
                        'importItemId' : $(e).val(),
                        'action' : action,
                        'item_start_date' : item_start_date,
                        'item_end_date' : item_end_date,
                    });
                });

                _this.takeActionBulk(payload);

                $('#bulk-actions .batch-action').prop('disabled', true);
            });
        });

        $(document).on("change", ".queue-item-action", function(event){
            var action = $(this).val();
            if(!action || action == ""){
                return;
            }
            if (action == "decline"){
                abcsetup.alerts.prompt('Decline Event Item', 'Please specify a reason to decline this item:', function (resp) {
                    if(resp[0] == true){
                        abcsetup.blockUI(true);
                        var importItemId = $(this).data('import-item-id');
                        axios.post('/api/new_customer_matching/import_items/' + importItemId + '/actions/' + action, {reason: resp[1]}).then(function (response) {
                            window.LaravelDataTables["app_data_tables_new_customer_matching_import_item_data_table"].ajax.reload();
                        });
                    }
                });
            }
            var importItemId = $(this).data('import-item-id');
            if(action == "wac"){
                var wac = $(this).siblings('.wac').val();
                axios.put('/api/new_customer_matching/import_items/' + importItemId, {current_bid: wac});
            }
            axios.post('/api/new_customer_matching/import_items/' + importItemId + '/actions/' + action).then(function (response) {
                 window.LaravelDataTables["app_data_tables_new_customer_matching_import_item_data_table"].ajax.reload();
            });
        });

        /* Handle Item Start Date & Item End Date */
        $(document).on("change", ".item_start_date", function(e) {
            $(this).parents('tr').find('.batch').data('item_start_date', $(this).val());
        });

        $(document).on("change", ".item_end_date", function(e) {
            $(this).parents('tr').find('.batch').data('item_end_date', $(this).val());
        });

        if (abcsetup.userRole.class == 'fs_cm') {
            $(document).on('click', 'button[name="form_action"]', function(e) {
                if ($(this).val() == 'approve' || $(this).val() == 'wac') {
                    const item_start_date = $('#item_start_date_' + $(this).data('id')).val();
                    const item_end_date = $('#item_end_date_' + $(this).data('id')).val();

                    $(this).parents('tr').find('input[name="item_start_date"]').val(item_start_date);
                    $(this).parents('tr').find('input[name="item_end_date"]').val(item_end_date);

                    if (!abcsetup.new_customer_matching.events.items.index.validateItemDates(item_start_date, item_end_date)) {
                        e.preventDefault();
                        abcsetup.alerts.show("Invalid Item Dates", "Please enter start and end dates for the item that are within the Event Start and End Dates. The Item Start Date must also not be after the Item End Date & the Item End Date must not be before the Item Start Date.");
                    }
                }
            });

            $(document).on('click', '.reassign-btn', function(e) {
                let item_id = $(this).data('id');
                let category_selection = abcsetup.new_customer_matching.events.items.index.getCategories(item_id);
                
                abcsetup.alerts.confirm(
                    "Reassign Item",
                    `<p>Are you sure you want to reassign this item to a different category manager? Please select the Category & Manager you believe this item should be handled by:</p>${category_selection}`,
                    function(resp) {
                        if (resp) {
                            abcsetup.blockUI(true);
                            let selected = $(`#category_reassign_${item_id} option:selected`);

                            axios.post('/api/new_customer_matching/import_items/'+item_id+'/reassign', {
                                category: selected.data('name'),
                                category_manager: selected.data('cm_name'),
                                new_cm_user_id: selected.data('cm_id')
                            })
                            .then(response => {
                                const data = response.data;

                                if (data.success && data.message) {
                                    abcsetup.unblockUI();

                                    if (data.completed == true) {
                                        abcsetup.alerts.confirm(
                                            "Reassignment Succesful.",
                                            `<p>${data.message}</p><p>${data.deadline}</p><p>You have completed all tasks for this Event, please click 'Ok' below to navigate to your dashboard.</p>`,
                                            function(resp) {
                                                if (resp) {
                                                    window.location.href = '/dashboard';
                                                }
                                            }
                                        );
                                    } else {
                                        abcsetup.alerts.show("Reassignment Succesful", `<p>${data.message}</p><p>${data.deadline}</p>`);
                                        abcsetup.new_customer_matching.events.items.index.reloadTables();
                                    }
                                }
                            })
                            .catch(error => {
                                abcsetup.unblockUI();
                                console.error(error);
                                abcsetup.alerts.show("Reassignment Failed", `An error occurred while trying to reassign the item. Please try again later. ${error.response.data.message}`);
                            });
                        }
                    }
                )
            });

            $(document).on('click', '.batch-reassign', function(e) {
                abcsetup.alerts.confirm(
                    "Reassign Items",
                    "Are you sure you want to reassign the selected item(s)? Please select the desired category to reassign the items to, you can only choose 1 category." + abcsetup.new_customer_matching.events.items.index.getCategories(),
                    function(resp) {
                        if (resp) {
                            abcsetup.blockUI(true);
                            let total = $('input.batch').length;
                            let checked = $('input.batch:checked').length;
                            let selected = $(`#category_reassign_bulk option:selected`);
                            let payload = {
                                category: selected.data('name'),
                                category_manager: selected.data('cm_name'),
                                new_cm_user_id: selected.data('cm_id'),
                                new_customer_matching_event_id: $('#new_customer_matching_event_id').val(),
                                item_ids: []
                            };

                            $('input.batch:checked').each(async function(i, e){            
                                payload.item_ids.push($(e).val());
                            });

                            axios.post('/api/new_customer_matching/batch_reassign_items', payload)
                                .then(response => {
                                    const data = response.data;

                                    if (data.success && data.message) {
                                        abcsetup.unblockUI();

                                        if (checked >= total) {
                                            abcsetup.alerts.confirm(
                                                "Reassignment Succesful.",
                                                `<p>${data.message}</p><p>${data.deadline}</p><p>You have completed all tasks for this Event, please click 'Ok' below to navigate to your dashboard.</p>`,
                                                function(resp) {
                                                    if (resp) {
                                                        window.location.href = '/dashboard';
                                                    }
                                                }
                                            );
                                        } else {
                                            abcsetup.alerts.show("Reassignment Succesful", `<p>${data.message}</p><p>${data.deadline}</p>`,);
                                            abcsetup.new_customer_matching.events.items.index.reloadTables();
                                        }
                                    }
                                })
                                .catch(error => {
                                    abcsetup.unblockUI();
                                    console.error(error);
                                    abcsetup.alerts.show("Reassignment Failed", `An error occurred while trying to reassign the item(s). Please try again later. ${error.response.data.message}`);
                                });
                        }
                    }
                )
            });
        }

        abcsetup.new_customer_matching.events.matches_datatable.init();
    },

    takeActionBulk: async function(payload) {
        let count = 0;

        for (let i = 0; i < payload.length; i++) {
            if (typeof payload[i].item_start_date === 'undefined' || payload[i].item_start_date === null) {
                payload[i].item_start_date = $('#event_start_date').val();
            }
    
            if (typeof payload[i].item_end_date === 'undefined' || payload[i].item_end_date === null) {
                payload[i].item_end_date = $('#event_end_date').val();
            }

            abcsetup.blockUI(true);

            axios.post('/api/new_customer_matching/import_items/' + payload[i].importItemId + '/actions/' + payload[i].action, {
                'item_start_date': payload[i].item_start_date,
                'item_end_date': payload[i].item_end_date
            }).then(function (response) {
                count++;
                if (count >= (payload.length-1)) {
                    abcsetup.alerts.flashMessage(response.data.message);
                    window.LaravelDataTables["app_data_tables_new_customer_matching_import_item_data_table"].ajax.reload();
                }
            });

            await abcsetup.sleep(250);
        }
    },

    takeAction: function(importItemId, action, item_start_date, item_end_date) {
        abcsetup.blockUI(true);

        if (typeof item_start_date === 'undefined' || item_start_date === null) {
            item_start_date = $('#event_start_date').val();
        }

        if (typeof item_end_date === 'undefined' || item_end_date === null) {
            item_end_date = $('#event_end_date').val();
        }

        axios.post('/api/new_customer_matching/import_items/' + importItemId + '/actions/' + action, {
            'item_start_date': item_start_date,
            'item_end_date': item_end_date
        }).then(function (response) {
            abcsetup.alerts.flashMessage(response.data.message);
            window.LaravelDataTables["app_data_tables_new_customer_matching_import_item_data_table"].ajax.reload();
        });
        $('#batch-all').prop('checked', false);
    },

    setBid: function(importItemId, matchId) {
        axios.post('/api/new_customer_matching/import_items/' + importItemId + '/bids/' + matchId + '/set').then(function (response) {
            abcsetup.new_customer_matching.events.items.index.reloadTables();
        });
    },

    updateDatatable: function(importItemId) {
        var urlParams = [];
        var subcategory_id = ($("#subcategory_id").val() == "") ? "" : $("#subcategory_id").val();
        var segment_id = ($("#segment_id").val() == "") ? "" : $("#segment_id").val();
        urlParams.push("strict="+($("#strict_matches").is(':checked') ? 1 : 0));
        urlParams.push("active="+($("#active_toggle").is(':checked') ? 1 : 0));
        urlParams.push("gnp="+($('#gnp_toggle').is(':checked') ? 1 : 0));
        urlParams.push(subcategory_id ? "subcategory_id="+ subcategory_id : "");
        urlParams.push(segment_id ? "segment_id="+ segment_id : "");

        window.LaravelDataTables["app_data_tables_new_customer_matching_matches_data_table"].ajax.url('/api/new_customer_matching/import_items/'+ importItemId +'/matches?'+urlParams.join("&")).load();
    },

    validateItemDates: function (item_start_date, item_end_date) {
        const event_start_date = moment($('#event_start_date').val(), 'YYYY-MM-DD');
        const event_end_date = moment($('#event_end_date').val(), 'YYYY-MM-DD');
        item_start_date = moment(item_start_date, 'YYYY-MM-DD');
        item_end_date = moment(item_end_date, 'YYYY-MM-DD');

        // Check if all dates are valid moments
        if (!event_start_date.isValid() || !event_end_date.isValid() ||
            !item_start_date.isValid() || !item_end_date.isValid()) {
            return false;
        }

        // Check if item start date is before or equal to item end date
        if (!item_start_date.isSameOrBefore(item_end_date)) {
            return false;
        }

        // Check if item start date is after or equal to event start date
        if (!item_start_date.isSameOrAfter(event_start_date)) {
            return false;
        }

        // Check if item end date is before or equal to event end date
        if (!item_end_date.isSameOrBefore(event_end_date)) {
            return false;
        }

        return true;
    },

    toggleFilterTypeBanner() {
        $('#strict_matches').is(':checked') && $('#active_toggle').is(':checked')
            ? $('.filter-banner').removeClass('d-none')
            : $('.filter-banner').addClass('d-none');
    },

    reloadTables() {
        try {
            if (abcsetup.page_name == 'new_customer_matching.events.matches.index') {
                window.LaravelDataTables["app_data_tables_new_customer_matching_item_match_data_table"].ajax.reload();
            } else {
                window.LaravelDataTables["app_data_tables_new_customer_matching_import_item_data_table"].ajax.reload();
            }

            window.LaravelDataTables["app_data_tables_new_customer_matching_matches_data_table"].ajax.reload();
        } catch (e) {
            console.error(e);
        } finally {
            abcsetup.unblockUI();
        }
    },

    getCategories: function(item_id = 'bulk') {
        let category_selection = `<div><select class="form-control" id="category_reassign_${item_id}">`;
        let categories = JSON.parse($('#category_list').val());

        categories.forEach(category => {
            category_selection += `
                <option
                    value="${category.category_id}"
                    data-name="${category.category_name}"
                    data-cm_name="${category.user_name}"
                    data-cm_id="${category.user_id}"
                >
                    ${category.category_name} - (${category.user_name})
                </option>`;
        });

        return category_selection + '</select></div>';
    }
}